import Slider from "../../components/Slider/Slider"

const Home = () => {
    return (
        <>

<div className="section position-relative overflow-hidden">


<div className="hero-slider">
    <div className="swiper-container">
        <div className="swiper-wrapper">
            <Slider/>
       </div>
     </div>
</div>

    

</div>        

        </>
    )
}

export default Home;